import type {
  MultiStoreCenter,
  MultiStoreCenterDay,
  MultiStoreHourOptions,
} from '../../interface/multi-store';
import { getCentersWithHour, getNearHours, sortByDistance } from './centers';

// Elenco «Dove vuoi andare alle …?» dei centri inclusi, dato l'orario scelto:
// - liberi a quell'ora: il centro corrente per primo, poi per distanza;
// - non liberi: per distanza, ciascuno con gli orari più vicini prima e dopo;
// - senza ancora gli orari del giorno: in caricamento, oppure non disponibili se la richiesta
//   è fallita o il backend ha omesso il centro.
// dayCenters sono i centri di cui sono arrivati gli orari (il corrente c'è sempre).
export const getHourOptions = (
  included: MultiStoreCenter[],
  dayCenters: MultiStoreCenterDay[],
  unavailableIds: string[],
  hour: string
): MultiStoreHourOptions => {
  const withTimes = new Set(dayCenters.map((center) => center.pointOfSale.id));
  const missing = sortByDistance(
    included.filter((center) => !withTimes.has(center.pointOfSale.id))
  );

  return {
    free: getCentersWithHour(dayCenters, hour),
    busy: sortByDistance(
      dayCenters.filter((center) => !center.times.includes(hour))
    ).map((center) => ({ center, nearHours: getNearHours(center, hour) })),
    loading: missing.filter(
      (center) => !unavailableIds.includes(center.pointOfSale.id)
    ),
    unavailable: missing.filter((center) =>
      unavailableIds.includes(center.pointOfSale.id)
    ),
  };
};
